import type { SVGProps } from 'react';
import React from 'react';

export const NoItemsIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="76"
      height="74"
      viewBox="0 0 76 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.3"
        d="M20.4911 66.3635C24.1375 66.3635 27.0934 63.4105 27.0934 59.7677C27.0934 56.1249 24.1375 53.1719 20.4911 53.1719C16.8447 53.1719 13.8887 56.1249 13.8887 59.7677C13.8887 63.4105 16.8447 66.3635 20.4911 66.3635Z"
        fill="#D2FFF2"
      />
      <path
        opacity="0.3"
        d="M67.2966 38.236C66.2927 46.146 63.5524 54.6089 58.2065 60.7842C53.2184 66.5474 43.6631 71.0785 36.6061 66.2299C34.2405 64.6046 32.563 62.1299 31.4412 59.4911C30.3952 57.0353 30.2921 53.9256 28.9767 51.6506C24.159 43.3096 16.7506 38.5262 20.4211 27.9081C24.7462 15.3997 37.1197 7.88718 49.7962 6.02008C55.9208 5.11807 61.936 6.02008 64.8973 11.7812C67.6544 17.1407 67.8333 23.5494 67.8417 29.4451C67.8459 32.231 67.6797 35.2104 67.2966 38.236Z"
        fill="#D2FFF2"
      />
      <path
        d="M60.7072 58.6447H59.638C59.4023 58.6447 59.2129 58.4534 59.2129 58.22C59.2129 57.9866 59.4044 57.7953 59.638 57.7953H60.28V57.4504C60.28 57.2149 60.4715 57.0257 60.7051 57.0257C60.9387 57.0257 61.1303 57.217 61.1303 57.4504V58.22C61.1303 58.4555 60.9387 58.6447 60.7051 58.6447H60.7072ZM57.1861 58.6447H55.3466C55.1109 58.6447 54.9214 58.4534 54.9214 58.22C54.9214 57.9866 55.113 57.7953 55.3466 57.7953H57.1861C57.4218 57.7953 57.6112 57.9866 57.6112 58.22C57.6112 58.4534 57.4197 58.6447 57.1861 58.6447ZM52.8925 58.6447H51.053C50.8173 58.6447 50.6279 58.4534 50.6279 58.22C50.6279 57.9866 50.8194 57.7953 51.053 57.7953H52.8925C53.1283 57.7953 53.3177 57.9866 53.3177 58.22C53.3177 58.4534 53.1262 58.6447 52.8925 58.6447ZM48.599 58.6447H46.7595C46.5238 58.6447 46.3343 58.4534 46.3343 58.22C46.3343 57.9866 46.5259 57.7953 46.7595 57.7953H48.599C48.8347 57.7953 49.0241 57.9866 49.0241 58.22C49.0241 58.4534 48.8326 58.6447 48.599 58.6447ZM44.3054 58.6447H42.4659C42.2302 58.6447 42.0408 58.4534 42.0408 58.22C42.0408 57.9866 42.2323 57.7953 42.4659 57.7953H44.3054C44.5412 57.7953 44.7306 57.9866 44.7306 58.22C44.7306 58.4534 44.5391 58.6447 44.3054 58.6447ZM40.0119 58.6447H38.1724C37.9367 58.6447 37.7472 58.4534 37.7472 58.22C37.7472 57.9866 37.9388 57.7953 38.1724 57.7953H40.0119C40.2476 57.7953 40.437 57.9866 40.437 58.22C40.437 58.4534 40.2455 58.6447 40.0119 58.6447ZM35.7183 58.6447H33.8788C33.6431 58.6447 33.4537 58.4534 33.4537 58.22C33.4537 57.9866 33.6452 57.7953 33.8788 57.7953H35.7183C35.9541 57.7953 36.1435 57.9866 36.1435 58.22C36.1435 58.4534 35.9519 58.6447 35.7183 58.6447ZM31.4248 58.6447H29.5853C29.3496 58.6447 29.1601 58.4534 29.1601 58.22C29.1601 57.9866 29.3517 57.7953 29.5853 57.7953H31.4248C31.6605 57.7953 31.8499 57.9866 31.8499 58.22C31.8499 58.4534 31.6584 58.6447 31.4248 58.6447ZM27.1312 58.6447H25.2917C25.056 58.6447 24.8666 58.4534 24.8666 58.22C24.8666 57.9866 25.0581 57.7953 25.2917 57.7953H27.1312C27.3669 57.7953 27.5564 57.9866 27.5564 58.22C27.5564 58.4534 27.3648 58.6447 27.1312 58.6447ZM22.8377 58.6447H20.9982C20.7624 58.6447 20.573 58.4534 20.573 58.22C20.573 57.9866 20.7646 57.7953 20.9982 57.7953H22.8377C23.0734 57.7953 23.2628 57.9866 23.2628 58.22C23.2628 58.4534 23.0713 58.6447 22.8377 58.6447ZM18.5441 58.6447H16.7046C16.4689 58.6447 16.2795 58.4534 16.2795 58.22C16.2795 57.9866 16.471 57.7953 16.7046 57.7953H18.5441C18.7798 57.7953 18.9693 57.9866 18.9693 58.22C18.9693 58.4534 18.7777 58.6447 18.5441 58.6447ZM14.2506 58.6447H12.4111C12.1753 58.6447 11.9859 58.4534 11.9859 58.22C11.9859 57.9866 12.1774 57.7953 12.4111 57.7953H14.2506C14.4863 57.7953 14.6757 57.9866 14.6757 58.22C14.6757 58.4534 14.4842 58.6447 14.2506 58.6447ZM11.7081 56.8954C11.4724 56.8954 11.283 56.704 11.283 56.4706V54.633C11.283 54.3975 11.4745 54.2082 11.7081 54.2082C11.9417 54.2082 12.1333 54.3996 12.1333 54.633V56.4706C12.1333 56.7061 11.9417 56.8954 11.7081 56.8954ZM60.6967 55.4235C60.461 55.4235 60.2715 55.2322 60.2715 54.9988V53.1611C60.2715 52.9257 60.4631 52.7364 60.6967 52.7364C60.9303 52.7364 61.1218 52.9278 61.1218 53.1611V54.9988C61.1218 55.2343 60.9303 55.4235 60.6967 55.4235ZM11.7081 52.6061C11.4724 52.6061 11.283 52.4147 11.283 52.1813V50.3437C11.283 50.1082 11.4745 49.9189 11.7081 49.9189C11.9417 49.9189 12.1333 50.1103 12.1333 50.3437V52.1813C12.1333 52.4168 11.9417 52.6061 11.7081 52.6061ZM60.6967 51.1342C60.461 51.1342 60.2715 50.9429 60.2715 50.7095V48.8719C60.2715 48.6364 60.4631 48.4471 60.6967 48.4471C60.9303 48.4471 61.1218 48.6385 61.1218 48.8719V50.7095C61.1218 50.945 60.9303 51.1342 60.6967 51.1342ZM11.7081 48.3168C11.4724 48.3168 11.283 48.1254 11.283 47.892V46.0544C11.283 45.8189 11.4745 45.6297 11.7081 45.6297C11.9417 45.6297 12.1333 45.821 12.1333 46.0544V47.892C12.1333 48.1275 11.9417 48.3168 11.7081 48.3168ZM60.6967 46.845C60.461 46.845 60.2715 46.6536 60.2715 46.4202V44.5826C60.2715 44.3471 60.4631 44.1578 60.6967 44.1578C60.9303 44.1578 61.1218 44.3492 61.1218 44.5826V46.4202C61.1218 46.6557 60.9303 46.845 60.6967 46.845ZM11.7081 44.0275C11.4724 44.0275 11.283 43.8361 11.283 43.6028V41.7651C11.283 41.5296 11.4745 41.3404 11.7081 41.3404C11.9417 41.3404 12.1333 41.5317 12.1333 41.7651V43.6028C12.1333 43.8382 11.9417 44.0275 11.7081 44.0275ZM60.6967 42.5557C60.461 42.5557 60.2715 42.3643 60.2715 42.1309V40.2933C60.2715 40.0578 60.4631 39.8686 60.6967 39.8686C60.9303 39.8686 61.1218 40.0599 61.1218 40.2933V42.1309C61.1218 42.3664 60.9303 42.5557 60.6967 42.5557ZM11.7081 39.7382C11.4724 39.7382 11.283 39.5469 11.283 39.3135V37.4758C11.283 37.2403 11.4745 37.0511 11.7081 37.0511C11.9417 37.0511 12.1333 37.2424 12.1333 37.4758V39.3135C12.1333 39.549 11.9417 39.7382 11.7081 39.7382ZM60.6967 38.2664C60.461 38.2664 60.2715 38.075 60.2715 37.8417V36.004C60.2715 35.7685 60.4631 35.5793 60.6967 35.5793C60.9303 35.5793 61.1218 35.7706 61.1218 36.004V37.8417C61.1218 38.0771 60.9303 38.2664 60.6967 38.2664ZM11.7081 35.4489C11.4724 35.4489 11.283 35.2576 11.283 35.0242V33.1865C11.283 32.951 11.4745 32.7618 11.7081 32.7618C11.9417 32.7618 12.1333 32.9531 12.1333 33.1865V35.0242C12.1333 35.2597 11.9417 35.4489 11.7081 35.4489ZM60.6967 33.9771C60.461 33.9771 60.2715 33.7857 60.2715 33.5524V31.7147C60.2715 31.4792 60.4631 31.29 60.6967 31.29C60.9303 31.29 61.1218 31.4813 61.1218 31.7147V33.5524C61.1218 33.7879 60.9303 33.9771 60.6967 33.9771ZM11.7081 31.1596C11.4724 31.1596 11.283 30.9683 11.283 30.7349V28.8972C11.283 28.6617 11.4745 28.4725 11.7081 28.4725C11.9417 28.4725 12.1333 28.6638 12.1333 28.8972V30.7349C12.1333 30.9704 11.9417 31.1596 11.7081 31.1596ZM60.6967 29.6878C60.461 29.6878 60.2715 29.4965 60.2715 29.2631V27.4254C60.2715 27.1899 60.4631 27.0007 60.6967 27.0007C60.9303 27.0007 61.1218 27.192 61.1218 27.4254V29.2631C61.1218 29.4986 60.9303 29.6878 60.6967 29.6878ZM60.6967 25.3985C60.461 25.3985 60.2715 25.2072 60.2715 24.9738V23.1361C60.2715 22.9006 60.4631 22.7114 60.6967 22.7114C60.9303 22.7114 61.1218 22.9027 61.1218 23.1361V24.9738C61.1218 25.2093 60.9303 25.3985 60.6967 25.3985ZM60.6967 21.1092C60.461 21.1092 60.2715 20.9179 60.2715 20.6845V18.8468C60.2715 18.6113 60.4631 18.4221 60.6967 18.4221C60.9303 18.4221 61.1218 18.6134 61.1218 18.8468V20.6845C61.1218 20.92 60.9303 21.1092 60.6967 21.1092ZM60.6967 16.8199C60.461 16.8199 60.2715 16.6286 60.2715 16.3952V14.5575C60.2715 14.322 60.4631 14.1328 60.6967 14.1328C60.9303 14.1328 61.1218 14.3241 61.1218 14.5575V16.3952C61.1218 16.6307 60.9303 16.8199 60.6967 16.8199Z"
        fill="#B6C8E3"
      />
      <path
        d="M51.2804 67.1385H25.618C24.1973 67.1385 23.0439 65.9862 23.0439 64.567V27.8137C23.0439 26.3944 24.1973 25.2422 25.618 25.2422H51.2804C52.701 25.2422 53.8544 26.3944 53.8544 27.8137V64.567C53.8544 65.9862 52.701 67.1385 51.2804 67.1385ZM26.0452 66.2869H50.8552C52.0423 66.2869 53.0041 65.326 53.0041 64.1402V28.2384C53.0041 27.0525 52.0423 26.0916 50.8552 26.0916H26.0452C24.8582 26.0916 23.8963 27.0525 23.8963 28.2384V64.1402C23.8963 65.326 24.8582 66.2869 26.0452 66.2869Z"
        fill="#B6C8E3"
      />
      <path
        d="M49.866 63.9939H27.0618C26.7397 63.9939 26.4788 63.7332 26.4788 63.4115V28.3402C26.4788 28.0185 26.7397 27.7578 27.0618 27.7578H49.866C50.188 27.7578 50.449 28.0185 50.449 28.3402V63.4115C50.449 63.7332 50.188 63.9939 49.866 63.9939ZM27.3312 63.1424H49.5966V28.6073H27.3312V63.1424Z"
        fill="#B6C8E3"
      />
      <path
        d="M43.3036 25.9342H34.5607C34.1398 25.9342 33.7988 25.6188 33.7988 25.2298V24.6747C33.7988 24.2879 34.1398 23.9704 34.5607 23.9704H37.0169C37.1011 23.6108 37.3094 23.2828 37.623 23.0221C38.0187 22.6962 38.5386 22.5154 39.0879 22.5154C40.0729 22.5154 40.9274 23.1546 41.1463 23.9851C41.6577 23.9851 42.6385 23.9767 43.2994 23.9704H43.3036C43.7245 23.9704 44.0655 24.2858 44.0655 24.6747V25.2298C44.0655 25.6167 43.7245 25.9342 43.3036 25.9342ZM34.6512 25.0826H43.2152V24.824C43.0152 24.8261 42.5312 24.8303 42.0513 24.8345C41.6851 24.8366 41.3904 24.8387 41.18 24.8387C41.0537 24.8387 40.9526 24.8387 40.8832 24.8387C40.7317 24.8366 40.6012 24.8345 40.477 24.7105C40.397 24.6306 40.3507 24.5213 40.3507 24.4077C40.3507 23.8547 39.7614 23.3711 39.09 23.3711C38.4186 23.3711 37.8419 23.7959 37.8293 24.3215C37.8524 24.4456 37.8167 24.5738 37.7367 24.6705C37.6567 24.7673 37.5367 24.824 37.4105 24.824H34.6533V25.0847L34.6512 25.0826Z"
        fill="#B6C8E3"
      />
      <path
        d="M39.604 24.1955C39.6119 23.9123 39.3885 23.6763 39.105 23.6683C38.8215 23.6604 38.5852 23.8836 38.5773 24.1669C38.5694 24.4501 38.7928 24.6861 39.0763 24.694C39.3598 24.7019 39.5961 24.4787 39.604 24.1955Z"
        fill="#B6C8E3"
      />
      <path
        d="M47.4394 34.4354H28.5499C28.3142 34.4354 28.1248 34.2441 28.1248 34.0107C28.1248 33.7773 28.3163 33.5859 28.5499 33.5859H47.4394C47.6752 33.5859 47.8646 33.7773 47.8646 34.0107C47.8646 34.2441 47.673 34.4354 47.4394 34.4354Z"
        fill="#B6C8E3"
      />
      <path
        d="M47.4394 39.5213H28.5499C28.3142 39.5213 28.1248 39.33 28.1248 39.0966C28.1248 38.8632 28.3163 38.6719 28.5499 38.6719H47.4394C47.6752 38.6719 47.8646 38.8632 47.8646 39.0966C47.8646 39.33 47.673 39.5213 47.4394 39.5213Z"
        fill="#B6C8E3"
      />
      <path
        d="M47.4393 44.6073H28.5498C28.3141 44.6073 28.1246 44.4159 28.1246 44.1825C28.1246 43.9491 28.3162 43.7578 28.5498 43.7578H47.4393C47.675 43.7578 47.8644 43.9491 47.8644 44.1825C47.8644 44.4159 47.6729 44.6073 47.4393 44.6073Z"
        fill="#B6C8E3"
      />
      <path
        d="M47.4393 49.6934H28.5498C28.3141 49.6934 28.1246 49.5021 28.1246 49.2687C28.1246 49.0353 28.3162 48.844 28.5498 48.844H47.4393C47.675 48.844 47.8644 49.0353 47.8644 49.2687C47.8644 49.5021 47.6729 49.6934 47.4393 49.6934Z"
        fill="#B6C8E3"
      />
      <path
        d="M15.0904 26.5079H6.77476C6.53903 26.5079 6.34961 26.3166 6.34961 26.0832V22.37C6.34961 22.1345 6.54114 21.9453 6.77476 21.9453H15.0904C15.3261 21.9453 15.5155 22.1366 15.5155 22.37V26.0832C15.5155 26.3187 15.324 26.5079 15.0904 26.5079ZM7.20201 25.6564H14.6652V22.7927H7.1999V25.6564H7.20201Z"
        fill="#B6C8E3"
      />
      <path
        d="M15.0904 21.1329H6.77476C6.53903 21.1329 6.34961 20.9416 6.34961 20.7082V16.995C6.34961 16.7595 6.54114 16.5703 6.77476 16.5703H15.0904C15.3261 16.5703 15.5155 16.7616 15.5155 16.995V20.7082C15.5155 20.9437 15.324 21.1329 15.0904 21.1329ZM7.20201 20.2814H14.6652V17.4177H7.1999V20.2814H7.20201Z"
        fill="#B6C8E3"
      />
      <path
        d="M15.0904 15.7579H6.77476C6.53903 15.7579 6.34961 15.5666 6.34961 15.3332V11.62C6.34961 11.3845 6.54114 11.1953 6.77476 11.1953H15.0904C15.3261 11.1953 15.5155 11.3866 15.5155 11.62V15.3332C15.5155 15.5687 15.324 15.7579 15.0904 15.7579ZM7.20201 14.9064H14.6652V12.0427H7.1999V14.9064H7.20201Z"
        fill="#B6C8E3"
      />
      <g filter="url(#filter0_d_277_13485)">
        <path
          d="M15.0905 10.579H6.77493C6.5392 10.579 6.34978 10.3876 6.34978 10.1542C6.34978 9.68741 5.97135 9.30898 5.50454 9.30898H5.40478C5.24482 9.30898 5.0996 9.22068 5.02594 9.0777C4.95227 8.93683 4.9649 8.76441 5.05751 8.63616L6.42766 6.727L6.8086 6.19504L10.2434 1.40534C10.3213 1.296 10.4476 1.22872 10.5802 1.22662C10.7149 1.22451 10.8412 1.28339 10.9254 1.38852L14.6822 6.17822L16.5996 8.62144C16.7006 8.74969 16.7196 8.92421 16.648 9.06929C16.5764 9.21647 16.427 9.30898 16.2649 9.30898C15.8511 9.30898 15.5157 9.64444 15.5157 10.0583V10.1542C15.5157 10.3897 15.3241 10.579 15.0905 10.579ZM7.20218 8.88216C7.20218 9.34897 7.58061 9.7274 8.04742 9.7274H13.8201C14.287 9.7274 14.6654 9.34897 14.6654 8.88216C14.6654 8.64667 14.8569 8.45743 15.0905 8.45743C15.2118 8.45743 15.2797 8.31772 15.2049 8.22233L11.723 3.78595C11.1641 3.07385 10.0782 3.09744 9.55076 3.83312L7.50315 6.68915L7.1222 7.22111L6.55122 8.01779C6.41947 8.20162 6.55086 8.45743 6.77703 8.45743C7.01276 8.45743 7.20218 8.64877 7.20218 8.88216Z"
          fill="url(#paint0_linear_277_13485)"
        />
      </g>
      <path
        d="M65.4219 12.5094H47.7152C47.4795 12.5094 47.29 12.318 47.29 12.0846V5.14609C47.29 4.9106 47.4816 4.72136 47.7152 4.72136H48.6939L50.5649 3.20539C50.8933 2.93836 51.3626 2.92575 51.7057 3.17385L53.8545 4.72136H65.4198C65.6555 4.72136 65.8449 4.9127 65.8449 5.14609V12.0846C65.8449 12.3201 65.6534 12.5094 65.4198 12.5094H65.4219ZM51.2069 3.8614C51.1753 3.83827 51.1311 3.84038 51.1016 3.86351L49.1127 5.47409C49.0369 5.53507 48.9422 5.56871 48.8454 5.56871H48.1424V11.6557H64.9967V5.56871H53.7198C53.6314 5.56871 53.543 5.54137 53.4715 5.48881"
        fill="#B6C8E3"
      />
      <path
        d="M67.5728 14.2706H49.8661C49.6303 14.2706 49.4409 14.0792 49.4409 13.8459V6.90519C49.4409 6.6697 49.6324 6.48047 49.8661 6.48047H67.5728C67.8085 6.48047 67.9979 6.6718 67.9979 6.90519V13.8437C67.9979 14.0792 67.8064 14.2685 67.5728 14.2685V14.2706ZM50.2912 13.419H67.1455V7.33202H50.2912V13.419Z"
        fill="#B6C8E3"
      />
      <path
        d="M60.1222 10.7244H51.4972C51.2614 10.7244 51.072 10.5331 51.072 10.2997C51.072 10.0663 51.2635 9.875 51.4972 9.875H60.1222C60.3579 9.875 60.5473 10.0663 60.5473 10.2997C60.5473 10.5331 60.3558 10.7244 60.1222 10.7244Z"
        fill="#B6C8E3"
      />
      <path
        d="M65.3923 9.01351H51.3583C51.1225 9.01351 50.9331 8.82217 50.9331 8.58879C50.9331 8.3554 51.1246 8.16406 51.3583 8.16406H65.3923C65.628 8.16406 65.8174 8.3554 65.8174 8.58879C65.8174 8.82217 65.6259 9.01351 65.3923 9.01351Z"
        fill="#B6C8E3"
      />
      <path
        d="M60.2589 70.2215C59.1877 70.2215 58.3142 69.3511 58.3142 68.2787C58.3142 67.2064 59.1855 66.3359 60.2589 66.3359C61.3323 66.3359 62.2037 67.2064 62.2037 68.2787C62.2037 69.3511 61.3323 70.2215 60.2589 70.2215ZM60.2589 67.1896C59.657 67.1896 59.1666 67.6795 59.1666 68.2808C59.1666 68.8822 59.657 69.3721 60.2589 69.3721C60.8609 69.3721 61.3513 68.8822 61.3513 68.2808C61.3513 67.6795 60.8609 67.1896 60.2589 67.1896Z"
        fill="#B6C8E3"
      />
      <g filter="url(#filter1_d_277_13485)">
        <path
          d="M9.33828 66.4989C8.267 66.4989 7.39355 65.6284 7.39355 64.5561C7.39355 63.4838 8.26489 62.6133 9.33828 62.6133C10.4117 62.6133 11.283 63.4838 11.283 64.5561C11.283 65.6284 10.4117 66.4989 9.33828 66.4989ZM9.33828 63.4669C8.73634 63.4669 8.24595 63.9568 8.24595 64.5582C8.24595 65.1595 8.73634 65.6494 9.33828 65.6494C9.94022 65.6494 10.4306 65.1595 10.4306 64.5582C10.4306 63.9568 9.94022 63.4669 9.33828 63.4669Z"
          fill="url(#paint1_linear_277_13485)"
        />
      </g>
      <g filter="url(#filter2_d_277_13485)">
        <path
          d="M51.9098 21.0067C50.8385 21.0067 49.9651 20.1362 49.9651 19.0639C49.9651 17.9916 50.8364 17.1211 51.9098 17.1211C52.9832 17.1211 53.8545 17.9916 53.8545 19.0639C53.8545 20.1362 52.9832 21.0067 51.9098 21.0067ZM51.9098 17.9747C51.3079 17.9747 50.8175 18.4647 50.8175 19.066C50.8175 19.6673 51.3079 20.1572 51.9098 20.1572C52.5118 20.1572 53.0021 19.6673 53.0021 19.066C53.0021 18.4647 52.5118 17.9747 51.9098 17.9747Z"
          fill="url(#paint2_linear_277_13485)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.4573 11.1567C28.4573 11.3901 28.6467 11.5814 28.8824 11.5814C29.1161 11.5814 29.3076 11.3922 29.3076 11.1567V10.3729H30.0904C30.3241 10.3729 30.5156 10.1815 30.5156 9.94816C30.5156 9.71477 30.3262 9.52344 30.0904 9.52344H29.3076V8.74504C29.3076 8.51165 29.1161 8.32031 28.8824 8.32031C28.6488 8.32031 28.4573 8.50955 28.4573 8.74504V9.52344H27.6764C27.4427 9.52344 27.2512 9.71477 27.2512 9.94816C27.2512 10.1815 27.4406 10.3729 27.6764 10.3729H28.4573V11.1567Z"
        fill="url(#paint3_linear_277_13485)"
      />
      <path
        d="M40.5992 21.308C40.3635 21.308 40.1741 21.1167 40.1741 20.8833V18.4716C40.1741 18.2361 40.3656 18.0469 40.5992 18.0469C40.8328 18.0469 41.0244 18.2382 41.0244 18.4716V20.8833C41.0244 21.1188 40.8328 21.308 40.5992 21.308Z"
        fill="#B6C8E3"
      />
      <path
        d="M41.8072 20.0994H39.3932C39.1574 20.0994 38.968 19.9081 38.968 19.6747C38.968 19.4413 39.1595 19.25 39.3932 19.25H41.8072C42.043 19.25 42.2324 19.4413 42.2324 19.6747C42.2324 19.9081 42.0409 20.0994 41.8072 20.0994Z"
        fill="#B6C8E3"
      />
      <g filter="url(#filter3_d_277_13485)">
        <path
          d="M17.8957 50.4721C17.66 50.4721 17.4706 50.2807 17.4706 50.0473V47.6357C17.4706 47.4002 17.6621 47.2109 17.8957 47.2109C18.1293 47.2109 18.3209 47.4023 18.3209 47.6357V50.0473C18.3209 50.2828 18.1293 50.4721 17.8957 50.4721Z"
          fill="url(#paint4_linear_277_13485)"
        />
      </g>
      <g filter="url(#filter4_d_277_13485)">
        <path
          d="M19.1039 49.2635H16.6898C16.4541 49.2635 16.2646 49.0722 16.2646 48.8388C16.2646 48.6054 16.4562 48.4141 16.6898 48.4141H19.1039C19.3396 48.4141 19.529 48.6054 19.529 48.8388C19.529 49.0722 19.3375 49.2635 19.1039 49.2635Z"
          fill="url(#paint5_linear_277_13485)"
        />
      </g>
      <g filter="url(#filter5_d_277_13485)">
        <circle
          cx="67.8418"
          cy="37.2077"
          r="3.62178"
          fill="url(#paint6_linear_277_13485)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_277_13485"
          x="0.90367"
          y="0.140002"
          width="19.8618"
          height="17.5015"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.98804"/>
          <feGaussianBlur stdDeviation="2.0373"/>
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0771667 0 0 0 0 1 0 0 0 0 0.0583333 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_277_13485"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_277_13485"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_277_13485"
          x="3.31895"
          y="61.5267"
          width="12.0386"
          height="12.0347"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.98804"/>
          <feGaussianBlur stdDeviation="2.0373"/>
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0771667 0 0 0 0 1 0 0 0 0 0.0583333 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_277_13485"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_277_13485"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_277_13485"
          x="45.8905"
          y="16.0345"
          width="12.0386"
          height="12.0347"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.98804"/>
          <feGaussianBlur stdDeviation="2.0373"/>
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0771667 0 0 0 0 1 0 0 0 0 0.0583333 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_277_13485"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_277_13485"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_277_13485"
          x="13.396"
          y="46.1244"
          width="8.99955"
          height="11.4104"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.98804"/>
          <feGaussianBlur stdDeviation="2.0373"/>
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0771667 0 0 0 0 1 0 0 0 0 0.0583333 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_277_13485"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_277_13485"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_277_13485"
          x="12.19"
          y="47.3275"
          width="11.4136"
          height="8.99857"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.98804"/>
          <feGaussianBlur stdDeviation="2.0373"/>
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0771667 0 0 0 0 1 0 0 0 0 0.0583333 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_277_13485"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_277_13485"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_277_13485"
          x="60.1454"
          y="32.4994"
          width="15.3927"
          height="15.3929"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.98804"/>
          <feGaussianBlur stdDeviation="2.0373"/>
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0771667 0 0 0 0 1 0 0 0 0 0.0583333 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_277_13485"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_277_13485"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_277_13485"
          x1="3.91017"
          y1="2.25819"
          x2="23.1682"
          y2="3.24591"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8FFF00"/>
          <stop
            offset="0.932292"
            stopColor="#DBFF00"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_277_13485"
          x1="7.03887"
          y1="63.0419"
          x2="13.44"
          y2="63.3043"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8FFF00"/>
          <stop
            offset="0.932292"
            stopColor="#DBFF00"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear_277_13485"
          x1="49.6104"
          y1="17.5497"
          x2="56.0115"
          y2="17.8121"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8FFF00"/>
          <stop
            offset="0.932292"
            stopColor="#DBFF00"
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear_277_13485"
          x1="26.9537"
          y1="8.32031"
          x2="34.337"
          y2="8.61412"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BDFF00"/>
          <stop
            offset="0.817013"
            stopColor="#05FF00"
          />
        </linearGradient>
        <linearGradient
          id="paint4_linear_277_13485"
          x1="17.393"
          y1="47.5707"
          x2="18.7946"
          y2="47.5856"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8FFF00"/>
          <stop
            offset="0.932292"
            stopColor="#DBFF00"
          />
        </linearGradient>
        <linearGradient
          id="paint5_linear_277_13485"
          x1="15.967"
          y1="48.5078"
          x2="21.2183"
          y2="49.3342"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8FFF00"/>
          <stop
            offset="0.932292"
            stopColor="#DBFF00"
          />
        </linearGradient>
        <linearGradient
          id="paint6_linear_277_13485"
          x1="63.5594"
          y1="34.3849"
          x2="75.4806"
          y2="34.8732"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8FFF00"/>
          <stop
            offset="0.932292"
            stopColor="#DBFF00"
          />
        </linearGradient>
      </defs>
    </svg>
  );
};